import { memoryRepository } from '../repositories/memory-repository';

async function getMemoryChapters() {
    return memoryRepository.getChapters();
}

export {
    getMemoryChapters
};
